import { render, staticRenderFns } from "./AdminReferral.vue?vue&type=template&id=60032102&scoped=true"
import script from "./AdminReferral.vue?vue&type=script&lang=js"
export * from "./AdminReferral.vue?vue&type=script&lang=js"
import style0 from "./AdminReferral.vue?vue&type=style&index=0&id=60032102&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60032102",
  null
  
)

export default component.exports